const cardPresenceOptions =[
  {
    "key": "CARD_PRESENT",
    "text": "Card present"
  },
  {
    "key": "CARD_NOT_PRESENT",
    "text": "Card not present"
  },
];

export default cardPresenceOptions;
